(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amzo-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__amzoBeforeAfter) return;
    window.__amzoBeforeAfter = true;
    document.addEventListener('input', function (event) {
      var range = event.target;
      if (!range || !range.classList || !range.classList.contains('amzo-ba__range')) return;
      var frame = range.closest('.amzo-ba__frame');
      if (frame) frame.style.setProperty('--pos', range.value + '%');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amzo-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__amzoQuickAdd) return;
    window.__amzoQuickAdd = true;
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-amzo-atc]')) return;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      var data = new FormData(form);
      try {
        data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        data.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      } catch (e) {}
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Error');
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); })
        .finally(function () {
          if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
        });
    });
  })();
  (function () {
    if (window.__amzoCollection) return;
    window.__amzoCollection = true;
    function opener(d) { return document.querySelector('[aria-controls="' + d.id + '"]'); }
    function open(d) {
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('amzo-lock');
      var b = opener(d);
      if (b) b.setAttribute('aria-expanded', 'true');
      var first = d.querySelector('.amzo-cg__close');
      if (first) setTimeout(function () { first.focus(); }, 60);
    }
    function close(d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('amzo-lock');
      var b = opener(d);
      if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var o = e.target.closest('[data-amzo-drawer-open]');
      if (o) {
        var dr = document.getElementById(o.getAttribute('aria-controls'));
        if (dr) { e.preventDefault(); open(dr); }
        return;
      }
      var c = e.target.closest('[data-amzo-drawer-close]');
      if (c) {
        var d = c.closest('[data-amzo-drawer]');
        if (d) { e.preventDefault(); close(d); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-amzo-drawer].is-open').forEach(close);
    });
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el.matches || !el.matches('[data-amzo-autosubmit]')) return;
      var f = el.form;
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.classList || !f.classList.contains('amzo-cg__form')) return;
      f.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amzo-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__amzoFooter) return;
    window.__amzoFooter = true;
    var mq = window.matchMedia('(min-width: 750px)');
    function sync() {
      document.querySelectorAll('.amzo-ft__acc').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
        else if (!d.hasAttribute('data-touched')) d.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('.amzo-ft__acc > summary');
      if (summary) {
        if (mq.matches) e.preventDefault();
        else summary.parentElement.setAttribute('data-touched', '');
        return;
      }
      var top = e.target.closest && e.target.closest('.amzo-ft__top');
      if (top) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amzo-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__amzoQuickAdd) return;
    window.__amzoQuickAdd = true;
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[data-amzo-atc]')) return;
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return;
      event.preventDefault();
      var button = form.querySelector('[type="submit"]');
      if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
      var data = new FormData(form);
      try {
        data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        data.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
      } catch (e) {}
      var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || 'Error');
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res);
        })
        .catch(function () { HTMLFormElement.prototype.submit.call(form); })
        .finally(function () {
          if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
